
/** 
 * Informações para os campos do form
 * @type {{
 *   groups: Array<{
 *      header: string,
 *      fields: Array<{
 *        label: string,
 *        placeholder: string,
 *        name: string,
 *        type: string,
 *        size: number,
 *        className: string
 *      }>
 *   }
 * }>} 
*/
export const getFormFields = (benefs) => {
    const beneficios = [...benefs.map(item => {
        return {
            value: item.cod,
            label: `${item.sigla} - ${item.nome}`
        }
    })]
    beneficios.unshift({value: '', label: '...'});

    return {
        groups: [
            {
                header: '',
                fields: [
                    {
                        label: 'Custo',
                        placeholder: '',
                        name: 'benefCod',
                        type: 'select',
                        options: beneficios,
                        size: 12,
                    },
                ]
            },
            {
                // header: 'Valores padrões do benefício', 
                shouldRender: (form) => {
                    return !['', null, undefined].includes(form.benefCod);
                },
                fields: [
                    {
                        label: 'Valor Custo Padrão',
                        placeholder: '',
                        name: 'valor',
                        type: 'currency',
                        size: 4,
                        // readOnly: true,
                        disabled: true,
                        defaultValue: 0
                    },
                    {
                        label: 'Período do Valor',
                        placeholder: '',
                        name: 'periodoValor',
                        type: 'select',
                        options: [
                            { label: '...' },
                            { label: 'Diário', value: 'dia' },
                            { label: 'Mensal', value: 'mes' },
                        ],
                        size: 4,
                        // readOnly: true,
                        disabled: true,
                    },
                    {
                        label: 'Base Aliq.Desconto',
                        placeholder: '',
                        name: 'baseAliqDesc',
                        type: 'select',
                        options: [
                            { label: 'Salário', value: 'salario' },
                            { label: 'Custo adicional', value: 'beneficio' },
                        ],
                        size: 4,
                        // readOnly: true,
                        disabled: true,
                    },
                ]
            }
        ]
    };
}

const BeneficioColabNewInfo = { getFormFields };

export default BeneficioColabNewInfo;
